import { EcommerceAPI } from "../Client";

export const getProductCategoriesApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/product/categories`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createProductCategoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/product/categories`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductCategoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/product/categories`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductCategoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/product/categories?id=${payload?.id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const productCategoryFileUploadApi = async (payload) => {
  try {
    const formData = new FormData();

    payload.files.forEach((file) => {
      formData.append("file", file); // important
    });

    const response = await EcommerceAPI.post(`/product/category/image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
